// extracted by mini-css-extract-plugin
export var boldText = "_2x-4";
export var checkboxContainer = "_2x-6";
export var closeIcon = "_2x-g";
export var container = "_2x-0";
export var drawer = "_2x-8";
export var drawerContent = "_2x-9";
export var extraSmallText = "_2x-5";
export var fulfillmentGroupTable = "_2x-e";
export var largeText = "_2x-3";
export var loadingSpinnerContainer = "_2x-h";
export var mediumText = "_2x-2";
export var narrow = "_2x-f";
export var notificationLink = "_2x-j";
export var packageCheckIconContainer = "_2x-7";
export var slideoutHeaderContainer = "_2x-a";
export var slideoutModal = "_2x-c";
export var stickyHeaderWrapper = "_2x-b";
export var table = "_2x-i";
export var tableContainer = "_2x-d";
export var tertiaryText = "_2x-1";